<template>
  <div v-if="!inQlw" class="tags-view-container align-center">
    <!-- 标签页 -->
    <!--
      TODO: 当标签数量过多时，需要添加滚动条
    -->
    <div
      v-for="(tag, tagIndex) in visitedViews"
      :key="tag.path"
      style="margin: 0 3px;">
      <!--   :to="{ path: tag.path, query: tag.query, fullPath: tag.fullPath }" -->
      <router-link
        :to="tag.fullPath || tag.path"
        tag="span"
        :class="['tags-view-item', 'cursor-pointer', isActive(tag)? 'active' : '']"
        @click.middle.native="!isAffix(tag)? closeSelectedTag(tag, tagIndex) : '' "
        @contextmenu.prevent.native="openMenu(tag, tagIndex,$event)">
        {{ tag.title }}
        <span v-if="!isAffix(tag)" class="el-icon-close" @click.prevent.stop="closeSelectedTag(tag, tagIndex)" />
      </router-link>
    </div>
    <!-- 右键菜单 -->
    <ul v-if="showContextmenu" :style="{left: left + 'px', top: top + 'px'}" class="contextmenu">
      <!-- <li @click.stop="$route.path !== selectedTag.path? '' : refreshSelectedTag()" :class="[$route.path !== selectedTag.path? 'banclick' : '']">
        重新加载
      </li> -->
      <li @click.stop="selectedTag.meta.affix? '' : closeSelectedTag(selectedTag)" :class="[selectedTag.meta.affix? 'banclick' : '']">
        关闭标签页
      </li>
      <li @click.stop="commonBanclick || closeLeftBanclick? '' : closeLeftTags()" :class="[commonBanclick || closeLeftBanclick? 'banclick' : '']">
        关闭左侧标签页
      </li>
      <li @click.stop="commonBanclick || closeRightBanclick? '' : closeRightTags()" :class="[commonBanclick || closeRightBanclick? 'banclick' : '']">
        关闭右侧标签页
      </li>
      <li @click.stop="commonBanclick? '' : closeOthersTags()" :class="[commonBanclick? 'banclick' : '']">
        关闭其它标签页
      </li>
      <li @click.stop="closeAllBanclick? '' : closeAllTags()" :class="[closeAllBanclick? 'banclick' : '']">
        关闭全部标签页
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters, mapActions,mapState } from 'vuex'
export default {
  data () {
    return {
      // 右键菜单显示隐藏
      showContextmenu: false,
      // 右键菜单位置
      top: 0,
      left: 0,
      // 当前右键标签页对象
      selectedTag: {},
      // 当前右键标签页的索引
      selectedTagIndex: 0
    }
  },
  computed: {
    ...mapState(["inQlw"]),
    ...mapGetters(['visitedViews']),
    commonBanclick () {
      const allTags = this.visitedViews.filter(tag => !tag.meta.affix)
      return (this.$route.path !== this.selectedTag.path) || (allTags.length === 0)
    },
    closeRightBanclick () {
      return this.selectedTagIndex === this.visitedViews.length - 1
    },
    closeLeftBanclick () {
      const allTags = this.visitedViews.filter(tag => !tag.meta.affix)
      return (allTags[0] && (allTags[0].path === this.selectedTag.path)) || this.selectedTag.meta.affix
    },
    closeAllBanclick () {
      const allTags = this.visitedViews.filter(tag => !tag.meta.affix)
      return allTags.length === 0
    }
  },
  watch: {
    showContextmenu (newValue) {
      if (newValue) {
        document.body.addEventListener('click', this.closeMenu)
      } else {
        document.body.removeEventListener('click', this.closeMenu)
      }
    }
  },
  mounted () {
  },
  methods: {
    ...mapActions(['delVisitedViews', 'moveVisitedViews']),
    // 判断是否是当前标签页
    isActive (tag) {
      return tag.path === this.$route.path
    },
    // 判断是否是需要固定的标签页
    isAffix (tag) {
      return tag.meta && tag.meta.affix
    },
    // 打开右键菜单
    openMenu (tag, tagIndex, e) {
      // TODO: 右键菜单，暂时隐藏
      return
      this.top = e.clientY
      this.left = e.clientX - (e.currentTarget.offsetWidth / 2)
      this.selectedTag = tag
      this.selectedTagIndex = tagIndex
      this.showContextmenu = true
    },
    // 关闭单个标签页
    closeSelectedTag (tag, tagIndex = this.selectedTagIndex) {
      this.delVisitedViews([tag])
      if (tag.path === this.$route.path) {
        this.$router.push(this.visitedViews[tagIndex - 1].path)
      }
      this.closeMenu()
    },
    // 重新加载标签页
    refreshSelectedTag () {
      this.$router.replace({
        path: '/redirect' + this.selectedTag.path
      })
      this.closeMenu()
    },
    // 关闭左侧标签页
    closeLeftTags () {
      // 最前面非固定标签页的索引
      let leftTags = this.visitedViews.slice(0, this.selectedTagIndex)
      leftTags = leftTags.filter(tag => !tag.meta.affix)
      this.delVisitedViews(leftTags)
      this.closeMenu()
    },
    // 关闭右侧标签页
    closeRightTags () {
      let rightTags = this.visitedViews.slice(this.selectedTagIndex + 1)
      rightTags = rightTags.filter(tag => !tag.meta.affix)
      this.delVisitedViews(rightTags)
      this.closeMenu()
    },
    // 关闭其它标签页
    closeOthersTags () {
      const othersTags = this.visitedViews.filter(tag => !tag.meta.affix && tag.path !== this.$route.path)
      this.delVisitedViews(othersTags)
      this.closeMenu()
    },
    // 关闭所有标签页
    closeAllTags () {
      const allTags = this.visitedViews.filter(tag => !tag.meta.affix)
      this.delVisitedViews(allTags)
      this.$router.push(this.visitedViews[this.visitedViews.length - 1].path)
      this.closeMenu()
    },
    // 关闭右键菜单
    closeMenu () {
      this.showContextmenu = false
    }
  }
}
</script>

<style lang="less" scoped>
.tags-view-container{
  width: 100%;
  height: 100%;
  border: 1px solid #d9d9d9;
  .tags-view-item{
    display: inline-block;
    font-size: 12px;
    padding: 5px;
    box-sizing: border-box;
    border: 1px solid #d9d9d9;
    &.active{
      background: #0960bd;
      border: 0;
      color: #FFF;
    }
  }
}
.contextmenu {
  margin: 0;
  background: #fff;
  z-index: 3000;
  position: absolute;
  list-style-type: none;
  padding: 5px 0;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 400;
  color: #333;
  box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, .3);
  li {
    margin: 0;
    padding: 7px 16px;
    cursor: pointer;
    &:hover {
      background: #eee;
    }
    &:nth-child(2),&:nth-child(4){
      border-bottom: 1px solid rgb(229, 231, 235);
    }
    &.banclick{
      color: rgb(229, 231, 235);
      &:hover{
      cursor: not-allowed;
        // cursor: no-drop;
        background: #FFF;
      }
    }
    .iconfont{
      font-size: 14px;
      font-weight: 500;
      padding-right: 5px;
    }
  }
}
.align-center{
  display: flex;
  align-items: center;
}
</style>
